import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "export-order-modal__content-container" }
const _hoisted_2 = { class: "export-order-modal__header" }
const _hoisted_3 = { class: "export-order-modal__body body" }
const _hoisted_4 = { class: "body__section" }
const _hoisted_5 = { class: "body__section-title" }
const _hoisted_6 = { class: "body__format-options" }
const _hoisted_7 = {
  class: "body__format-option",
  for: "not-export-default-format"
}
const _hoisted_8 = ["checked"]
const _hoisted_9 = { class: "body__format-label" }
const _hoisted_10 = {
  class: "body__format-option",
  for: "not-export-custom-format"
}
const _hoisted_11 = ["checked", "disabled"]
const _hoisted_12 = { class: "body__format-label" }
const _hoisted_13 = {
  class: "body__format-option",
  for: "not-export-file-format"
}
const _hoisted_14 = ["checked"]
const _hoisted_15 = { class: "body__format-label" }
const _hoisted_16 = {
  key: 0,
  class: "body__loading"
}
const _hoisted_17 = {
  key: 1,
  class: "body__error"
}
const _hoisted_18 = {
  key: 0,
  class: "body__template template-selector"
}
const _hoisted_19 = { class: "body__section-title template-selector__label" }
const _hoisted_20 = {
  key: 1,
  class: "body__template file-selector"
}
const _hoisted_21 = { class: "body__section-title file-selector__label" }
const _hoisted_22 = {
  key: 0,
  class: "file-selector__file-name"
}
const _hoisted_23 = { class: "export-order-modal__footer footer" }

import { computed, watch } from 'vue';
import { storeToRefs } from 'pinia';
import Modal from '@/components/modal/Modal.vue';
import TextButton from '@/components/input/Btn/TextButton.vue';
import SelectInput from '@/corePagesModule/components/SelectInput.vue';
import { i18n } from '@/i18n';
import { useExportOrderModalStore } from './useExportOrderModalStore';


export default /*@__PURE__*/_defineComponent({
  __name: 'ExportOrderModal',
  props: {
    modalState: { type: Boolean, default: false }
  },
  emits: ["closeModal", "exportOrder"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emits = __emit;

const t = i18n.t;
const store = useExportOrderModalStore();
const { state } = storeToRefs(store);
const { fetchTemplates, setSelectedFormat, setSelectedTemplateId, setSelectedFile } = store;

const templateOptions = computed(() => state.value.templates.map((template) => template.fileOriginalName));

const selectedTemplateLabel = computed(() => {
  const template = state.value.templates.find((item) => item.templateId === state.value.selectedTemplateId);
  return template?.fileOriginalName ?? '';
});

watch(
  () => props.modalState,
  async (isOpen) => {
    if (!isOpen) {
      store.$reset();
      return;
    }
    await fetchTemplates();
  }
);

const isCustomDisabled = computed(() => {
  if (state.value.loading) {
    return true;
  }
  return state.value.templates.length === 0;
});

const showTemplateSelector = computed(() => state.value.selectedFormat === 'custom');
const showFileSelector = computed(() => state.value.selectedFormat === 'file');

const isExportDisabled = computed(() => {
  if (state.value.loading) {
    return true;
  }
  if (state.value.selectedFormat === 'custom') {
    return state.value.selectedTemplateId === '';
  }
  if (state.value.selectedFormat === 'file') {
    return state.value.selectedFile === null;
  }
  return false;
});

/**
 * 書式種別の選択変更を処理する
 * @param format - 選択された書式種別
 */
const handleFormatChange = (format: 'default' | 'custom' | 'file') => {
  setSelectedFormat(format);
};

/**
 * テンプレート選択変更を処理する
 * @param label - 選択されたテンプレート名
 */
const handleTemplateSelect = (label: string) => {
  const template = state.value.templates.find((item) => item.fileOriginalName === label);
  setSelectedTemplateId(template?.templateId ?? '');
};

/**
 * ファイル選択ボタン押下
 */
const onClickSelectFileButton = () => {
  document.getElementById('not-export-order-file-input')?.click();
};

/**
 * ファイル選択変更を処理する
 * @param event - ファイル選択イベント
 */
const handleFileSelect = (event: Event) => {
  const target = event.target as HTMLInputElement;
  const file = target.files?.[0] ?? null;
  setSelectedFile(file);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Modal, {
    class: "export-order-modal",
    "modal-size": 400,
    "stretch-container": true,
    "scroll-off": true,
    padding: '24px 32px',
    "modal-state": _ctx.modalState,
    "border-radius": '16px',
    onOutsideClick: _cache[5] || (_cache[5] = ($event: any) => (emits('closeModal')))
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(t)('発注書の出力')), 1),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("p", _hoisted_5, _toDisplayString(_unref(t)('ダウンロードする書式')), 1),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("label", _hoisted_7, [
                _createElementVNode("input", {
                  id: "not-export-default-format",
                  class: "body__radio",
                  type: "radio",
                  name: "not-export-format",
                  checked: _unref(state).selectedFormat === 'default',
                  onChange: _cache[0] || (_cache[0] = ($event: any) => (handleFormatChange('default')))
                }, null, 40, _hoisted_8),
                _createElementVNode("span", _hoisted_9, _toDisplayString(_unref(t)('デフォルト書式')), 1)
              ]),
              _createElementVNode("label", _hoisted_10, [
                _createElementVNode("input", {
                  id: "not-export-custom-format",
                  class: "body__radio",
                  type: "radio",
                  name: "not-export-format",
                  checked: _unref(state).selectedFormat === 'custom',
                  disabled: isCustomDisabled.value,
                  onChange: _cache[1] || (_cache[1] = ($event: any) => (handleFormatChange('custom')))
                }, null, 40, _hoisted_11),
                _createElementVNode("span", _hoisted_12, _toDisplayString(_unref(t)('ユーザー設定書式')), 1)
              ]),
              _createElementVNode("label", _hoisted_13, [
                _createElementVNode("input", {
                  id: "not-export-file-format",
                  class: "body__radio",
                  type: "radio",
                  name: "not-export-format",
                  checked: _unref(state).selectedFormat === 'file',
                  onChange: _cache[2] || (_cache[2] = ($event: any) => (handleFormatChange('file')))
                }, null, 40, _hoisted_14),
                _createElementVNode("span", _hoisted_15, _toDisplayString(_unref(t)('出力書式選択')), 1)
              ])
            ]),
            (_unref(state).loading)
              ? (_openBlock(), _createElementBlock("p", _hoisted_16, _toDisplayString(_unref(t)('テンプレートを取得しています…')), 1))
              : _createCommentVNode("", true),
            (_unref(state).errorMessage && !showTemplateSelector.value && !showFileSelector.value)
              ? (_openBlock(), _createElementBlock("p", _hoisted_17, _toDisplayString(_unref(state).errorMessage), 1))
              : _createCommentVNode("", true)
          ]),
          (showTemplateSelector.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                _createElementVNode("p", _hoisted_19, _toDisplayString(_unref(t)('ダウンロードする書式を選択してください')), 1),
                _createVNode(SelectInput, {
                  class: "template-selector__select",
                  index: 1,
                  "model-value": selectedTemplateLabel.value,
                  options: templateOptions.value,
                  placeholder: _unref(t)('出力書式を選択'),
                  label: '',
                  disabled: _unref(state).loading,
                  "is-error": !!_unref(state).errorMessage,
                  "error-message": _unref(state).errorMessage,
                  "onUpdate:modelValue": handleTemplateSelect
                }, null, 8, ["model-value", "options", "placeholder", "disabled", "is-error", "error-message"])
              ]))
            : _createCommentVNode("", true),
          (showFileSelector.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                _createElementVNode("p", _hoisted_21, _toDisplayString(_unref(t)('ダウンロードする書式を選択してください')), 1),
                _createVNode(TextButton, {
                  "button-style": 'btn-primary',
                  size: 'btn-md',
                  "on-click": onClickSelectFileButton,
                  class: "file-selector__button"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('出力ファイル+')), 1)
                  ], undefined, true),
                  _: 1
                }),
                _createElementVNode("input", {
                  id: "not-export-order-file-input",
                  class: "file-selector__file-input",
                  type: "file",
                  accept: ".xlsx,.xls",
                  onChange: handleFileSelect
                }, null, 32),
                (_unref(state).selectedFile)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_22, _toDisplayString(_unref(state).selectedFile.name), 1))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_23, [
          _createVNode(TextButton, {
            class: "footer__button footer__button--cancel",
            onClick: _cache[3] || (_cache[3] = () => emits('closeModal'))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('もどる')), 1)
            ], undefined, true),
            _: 1
          }),
          _createVNode(TextButton, {
            class: "footer__button footer__button--confirm",
            disabled: isExportDisabled.value,
            onClick: _cache[4] || (_cache[4] = ($event: any) => (emits('exportOrder', _unref(state).selectedFile ?? undefined)))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('出力')), 1)
            ], undefined, true),
            _: 1
          }, 8, ["disabled"])
        ])
      ])
    ], undefined, true),
    _: 1
  }, 8, ["modal-state"]))
}
}

})